<template>
  <div>
    <data-table :data="jobBoardList"
                :entity="entity"
                :loading="loading"
                :sync-route="false"
                :show-pagination="false"
                :columns="columns"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                :clickable="false"
                @on-row-click="onTableRowClick"
                operations="refresh"
                :searchable="false"
                ref="table">
      <template v-slot:extra-buttons="{row}">
        <tooltip-icon-button icon="far fa-edit"
                             :content="$t('generic.edit')"
                             @click.stop="onTableRowClick(row)">
        </tooltip-icon-button>
      </template>
      <template v-slot:name="{row}">
        {{getJobBoardName(row)}}
      </template>
      <template v-slot:price="{row}">
        {{row.price || product.price | toCurrency}}
      </template>
      <template v-slot:active="{row}">
        <div class="d-flex align-items-center" @click.stop="">
          <base-switch :value="row.status"
                       @input="(evt) => updateStatus(evt, row)"
                       on-text="YES"
                       off-text="NO">
          </base-switch>
        </div>
      </template>
    </data-table>
    <modal :show.sync="showProductEditModal" v-if="selectedProduct">
      <fg-input v-model="selectedProduct.name"
                :label="$t('generic.name')"
                :placeholder="$t('generic.name')">
      </fg-input>
      <html-editor v-model="selectedProduct.text"
                :label="$t('generic.text')"
                :placeholder="$t('generic.text')">
      </html-editor>
      <fg-input :label="$t('generic.price')"
                :placeholder="$t('generic.price')"
                v-model.number="selectedProduct.price"
                type="number">
      </fg-input>

      <submit-button @click.native="updateProduct"></submit-button>
    </modal>
  </div>
</template>
<script>
  import ProductService from 'src/services/ProductService'
  import JobBoardService from 'src/services/JobBoardService'
  import HtmlEditor from 'src/components/Wysiwyg/RedactorWysiwyg'
  import TooltipIconButton from '@/components/Buttons/TooltipIconButton'
  import entities from 'src/config/entities'

  export default {
    name: 'products-job-board-settings',
    components: {
      HtmlEditor,
      TooltipIconButton,
    },
    props: {
      product: {
        type: Object,
        default: () => {
          return {
            job_days: 0
          }
        }
      }
    },
    data () {
      return {
        service: ProductService,
        entity: entities.PRODUCT,
        loading: false,
        jobBoardList: [],
        allJobBoards: [],
        productJobBoards: [],
        showProductEditModal: false,
        selectedProduct: null
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('settings.products.labels.jobBoard'),
            minWidth: '140px',
          },
          {
            prop: 'price',
            label: this.$t('generic.price'),
            minWidth: '140px',
          },
          {
            prop: 'active',
            label: this.$t('settings.products.labels.status'),
            minWidth: '140px'
          }
        ]
      },
      productId () {
        return this.$route.params.id
      }
    },
    methods: {
      onTableRowClick (row) {
        if (!row.status) {
          return
        }
        this.showProductEditModal = true
        this.selectedProduct = row
      },
      getJobBoardName (row) {
        if (!row.product_id) {
          return row.name
        }
        const jobBoard = this.$store.getters['config/getJobBoardById'](row.job_board_id) || {name: ''}
        return jobBoard.name
      },
      async updateStatus (val, row) {
        this.loading = true
        if (!val) {
          await ProductService.deleteProductFromJobBoard(this.productId, row.id)
        } else {
          let data = {
            product_id: parseInt(this.productId),
            job_board_id: parseInt(row.id),
            price: parseInt(this.product.price)
          }
          await ProductService.createProductOnJobBoard(this.productId, data)
        }
        await this.getProductData()
        this.loading = false
        row.status = val
      },
      async updateProduct () {
        let {name, text, price, id} = this.selectedProduct
        await ProductService.updateProductOnJobBoard(id, this.productId, {name, text, price})
        this.showProductEditModal = false
        this.selectedProduct = null
      },
      mapJobBoards (allJobBoards, productJobBoards) {
        return allJobBoards.map(j => {
          let status = false
          let productJobBoard = productJobBoards.find(p => p.job_board_id === j.id)
          if (productJobBoard) {
            status = true
          }
          return {
            ...j,
            ...productJobBoard,
            status
          }
        })
      },
      async getProductData () {
        let path = `${this.productId}/job-boards`
        let productJobBoards = await ProductService.getJobBoards({limit: 100}, path)
        let jobBoards = await JobBoardService.get()
        this.allJobBoards = jobBoards.data
        this.productJobBoards = productJobBoards.data
        this.jobBoardList = this.mapJobBoards(this.allJobBoards, this.productJobBoards)
      }
    },
    async created () {
      await this.getProductData()
    }
  }
</script>
<style>
</style>
